export default __webpack_public_path__ + "static/media/logo__technology__apollo.be781d5e.png";